module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-top"
  }, [_c('cIndex'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container-div"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "edition"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.goPayment(1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/guide1.png"),
      "alt": "图片"
    }
  }), _c('span', [_vm._v("青年版（17-44周岁）")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.goPayment(2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/guide2.png"),
      "alt": "图片"
    }
  }), _c('span', [_vm._v("中年版（45-60周岁）")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.goPayment(3)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/guide3.png"),
      "alt": "图片"
    }
  }), _c('span', [_vm._v("老年版（60周岁以上）")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.goPayment(4)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/guide4.png"),
      "alt": "图片"
    }
  }), _c('span', [_vm._v("儿童版（5-16周岁）")])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/banner6.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/banner2.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/banner3.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev swiper-button"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next swiper-button"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53720482","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/guide.vue
// module id = 755
// module chunks = 1